export default {
  contact: {
    hero: {
      eyebrow: 'Contatti',
      title: 'Parliamone',
      lead: 'Che si tratti di prime informazioni, pianificazione concreta o sopralluogo: aspettiamo il tuo messaggio.',
    },
    info: {
      partner: 'Il tuo partner per la tecnologia di sicurezza',
      owner: 'Titolare',
      address: 'Indirizzo',
      phone: 'Telefono',
      email: 'Email',
      hours: 'Orari',
      area: 'Area di servizio',
      viewAreas: 'Vedi tutte le aree di servizio',
    },
    form: {
      title: 'Richiesta progetto',
      lead: 'Compila il modulo. Ti risponderemo presto.',
      customerType: 'Privato o azienda *',
      select: 'Seleziona',
      privat: 'Privato',
      gewerbe: 'Azienda',
      name: 'Nome *',
      company: 'Azienda',
      phone: 'Telefono',
      email: 'Email *',
      projectLocation: 'Luogo del progetto',
      objectType: 'Tipo di immobile',
      objEfh: 'Casa unifamiliare',
      objMfh: 'Condominio',
      objLaden: 'Commercio / negozio',
      objBuero: 'Ufficio / studio',
      objGastronomie: 'Ristorazione',
      objLager: 'Magazzino / logistica',
      objWerkstatt: 'Officina / artigianato',
      objSonstige: 'Altro',
      service: 'Servizio desiderato',
      svcBeratung: 'Prima consulenza',
      svcPlanung: 'Pianificazione e offerta',
      svcInstallation: 'Installazione e configurazione',
      svcErweiterung: 'Ampliamento impianto esistente',
      svcWartung: 'Manutenzione / assistenza',
      svcCare: 'Richiesta SSG Care',
      systemStatus: 'Stato impianto',
      stNeu: 'Nuovo impianto',
      stBestehend: 'Ampliare impianto esistente',
      stAustausch: 'Sostituzione completa',
      stUnsicher: 'Non ancora sicuro',
      message: 'Messaggio',
      messagePlaceholder: 'Descrivi brevemente il tuo progetto o le tue domande...',
      maxChars: 'Massimo 500 caratteri',
      fileUpload: 'Carica file',
      fileHint: 'Foto, planimetrie o altri documenti (opzionale)',
      fileNote: 'Nota: i caricamenti sono trattati come «Uncollectable».',
      callback: 'Fascia oraria preferita',
      callbackNone: 'Nessuna richiamata',
      vormittag: 'Mattina',
      nachmittag: 'Pomeriggio',
      abend: 'Sera',
      consent: 'Ho letto l’informativa privacy e acconsento al trattamento dei miei dati per questa richiesta. *',
      success: 'Grazie per la tua richiesta. Ti risponderemo presto.',
      submit: 'Invia richiesta',
      submitting: 'Invio...',
    },
  },
};